import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

/** Utilities */
import { decryptUrlData, encryptUrlData } from '../../../../services/CryptoService';
import { mapDropdownOptions } from '../../../../components/finalForms/libs/mapDropdownOptions';

/** Common Components */
import Buttons from '../../../../components/ui/button/Buttons';
import CardSection from '../../../../components/ui/card/CardSection';
import FormCreator from '../../../../components/finalForms/FormCreator';

/** Common Servics & Data Files */
import ToastService from '../../../../services/toastService/ToastService';

/** Configuration Files */
import { AddProjectSynergyFormData } from './AddProjectSynergy.data';

/** RTK Query */
import { useLazyGetAllProjectsQuery } from '../../../../app/services/projectManagementAPI';
import { useLazyGetProjectModuleByProjectIdQuery } from '../../../../app/services/projectModuleAPI';
import { useGetAllProjectTeamListMutation } from '../../../../app/services/projectTeamManagementAPI';
import { useAddProjectSynergyMutation, useLazyGetAllSynergyPriorityQuery, useLazyGetAllSynergyTypesQuery } from '../../../../app/services/projectSynergyAPI';

const AddProjectSynergy = () => {

  const SynergyRef = useRef();
  const navigate = useNavigate();

  const { id } = useParams();
  const location = useLocation();

  let projectId = null;
  let projectCode = '';
  let projectName = '';
  let SelectedSynergyTypeID = null;

  const projectIdData = id ? decryptUrlData(id) : 0;

  if (typeof projectIdData === 'object' && projectIdData !== null) {
    projectId = projectIdData.projectId;
    projectCode = projectIdData?.projectCode;
    projectName = projectIdData?.projectName;
    SelectedSynergyTypeID = projectIdData?.SelectedSynergyTypeID;
  } else if (projectIdData) {
    projectId = projectIdData;
    projectCode = null;
    projectName = null;
  }

  const [shouldFormCretoerRerender, setShouldFormCretoerRerender] = useState(false);

  const [synergyForm, setSynergyForm] = useState(() => {
    const selectedSynergyType = SelectedSynergyTypeID || 0;

    return {
      ...AddProjectSynergyFormData,
      initialState: {
        ...AddProjectSynergyFormData.initialState,
        projectId: projectId,
        synergyTypeID: selectedSynergyType,
      },
      section: AddProjectSynergyFormData.section.filter(
        (sec) =>
          sec.sectionId === "ProjectSynergy" ||
          (selectedSynergyType === 1 && sec.sectionId === "ProjectSynergy3") ||
          (selectedSynergyType === 2 && sec.sectionId === "ProjectSynergy1") ||
          (selectedSynergyType === 3 && sec.sectionId === "ProjectSynergy2")
      ),
    };
  });

  const [getProjectModuleByProjectId, {
    isFetching: isgetProjectModuleByProjectIdfetching,
    isSuccess: isgetProjectModuleByProjectIdsuccess,
    data: isgetProjectModuleByProjectIdData,
  },] = useLazyGetProjectModuleByProjectIdQuery();

  const [addProjectSynergy, {
    isLoading: isaddProjectSynergyAddding,
    isSuccess: isaddProjectSynergySucess,
    data: addProjectSynergyData,
  },] = useAddProjectSynergyMutation();

  const [getAllSynergyTypes, {
    isFetching: isAllSynergyTypesFetching,
    isSuccess: isAllSynergyTypesSuccess,
    data: AllSynergyTypesData
  },] = useLazyGetAllSynergyTypesQuery();

  const [getAllSynergyPriority, {
    isFetching: isAllSynergyPriorityFetching,
    isSuccess: isAllSynergyPrioritySuccess,
    data: AllSynergyPriorityData
  },] = useLazyGetAllSynergyPriorityQuery();

  const [getAllProjects, {
    isFetching: isProjectFetching,
    isSuccess: isProjectFetched,
    data: allProjectData
  },] = useLazyGetAllProjectsQuery();

  const [getAssignedUserList, {
    isFetching: isAssignedUserNameFetching,
    isSuccess: isAssignedUserName,
    data: assignedUserNameData,
  },] = useGetAllProjectTeamListMutation();

  useEffect(() => {
    getProjectModuleByProjectId(projectId);
    getAllSynergyTypes();
    getAllSynergyPriority();
    getAllProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (projectId) {
      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 40,
        },
        projectId: projectId,
      }
      getAssignedUserList(request)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId])

  useEffect(() => {
    if (!isAssignedUserNameFetching && isAssignedUserName && assignedUserNameData) {
      const userNameList = assignedUserNameData.dataSource.map((item) => ({
        value: item.userId,
        label: item.userName,
      }));
      mapDropdownOptions(
        AddProjectSynergyFormData,
        'ProjectSynergy',
        'reportedBy',
        userNameList,
        'value',
        'label',
      );
    }
  }, [isAssignedUserName, isAssignedUserNameFetching, assignedUserNameData]);

  useEffect(() => {
    if (!isProjectFetching && isProjectFetched && allProjectData) {
      mapDropdownOptions(
        AddProjectSynergyFormData,
        'ProjectSynergy',
        'projectId',
        allProjectData,
        'projectId',
        'projectName',
      );
    }
    setShouldFormCretoerRerender(prevState => !prevState);
  }, [isProjectFetched, isProjectFetching, allProjectData]);

  useEffect(() => {
    if (!isAllSynergyTypesFetching && isAllSynergyTypesSuccess && AllSynergyTypesData) {
      mapDropdownOptions(
        AddProjectSynergyFormData,
        'ProjectSynergy',
        'synergyTypeID',
        AllSynergyTypesData,
        'synergyTypeID',
        'synergyTypeName',
      );
    }
    setShouldFormCretoerRerender(prevState => !prevState);
  }, [isAllSynergyTypesSuccess, isAllSynergyTypesFetching, AllSynergyTypesData]);

  useEffect(() => {
    if (!isAllSynergyPriorityFetching && isAllSynergyPrioritySuccess && AllSynergyPriorityData) {
      mapDropdownOptions(
        AddProjectSynergyFormData,
        'ProjectSynergy',
        'priorityId',
        AllSynergyPriorityData,
        'priorityId',
        'priorityName',
      );
    }
  }, [isAllSynergyPrioritySuccess, isAllSynergyPriorityFetching, AllSynergyPriorityData]);

  useEffect(() => {
    if (
      !isgetProjectModuleByProjectIdfetching &&
      isgetProjectModuleByProjectIdsuccess &&
      isgetProjectModuleByProjectIdData
    ) {
      mapDropdownOptions(
        AddProjectSynergyFormData,
        'ProjectSynergy1',
        'affectedId',
        isgetProjectModuleByProjectIdData,
        'projectModuleId',
        'projectModule',
      );
    }
  }, [
    isgetProjectModuleByProjectIdfetching,
    isgetProjectModuleByProjectIdsuccess,
    isgetProjectModuleByProjectIdData,
  ]);


  const handleFieldChange = (dataField, updatedFormData) => {
    const { synergyTypeID, projectId } = updatedFormData;

    const getValue = (field) => (field && typeof field === "object" ? field.value : field);

    if (dataField === "synergyTypeID" || dataField === "projectId") {
      const selectedSynergyType = getValue(synergyTypeID)
      const selectedProjectId = getValue(projectId) || projectId;

      let form = { ...AddProjectSynergyFormData };
      form.initialState = {
        ...updatedFormData,
        synergyTypeID: selectedSynergyType,
        projectId: selectedProjectId,
        ...(dataField === "projectId" && { reportedBy: null })
      };

      if (selectedProjectId) {
        const request = {
          pagination: {
            pageNumber: 1,
            pageSize: 40,
          },
          projectId: selectedProjectId,
        }
        getAssignedUserList(request)
      }

      form.section = AddProjectSynergyFormData.section.filter(
        (sec) =>
          sec.sectionId === "ProjectSynergy" ||
          (selectedSynergyType === 1 && sec.sectionId === "ProjectSynergy3") ||
          (selectedSynergyType === 2 && sec.sectionId === "ProjectSynergy1") ||
          (selectedSynergyType === 3 && sec.sectionId === "ProjectSynergy2")
      );

      setSynergyForm(form);
    }
  };

  const handleSubmit = () => {
    if (SynergyRef.current?.getFormData) {
      const formData = SynergyRef.current.getFormData();
      if (formData) {
        const request = {
          projectId: formData.projectId && typeof formData.projectId === 'object' ? formData.projectId.value : formData.projectId,
          synergyTypeID: formData.synergyTypeID && typeof formData.synergyTypeID === 'object' ? formData.synergyTypeID.value : formData.synergyTypeID,
          title: formData.title,
          priorityId: formData.priorityId && typeof formData.priorityId === 'object' ? formData.priorityId.value : formData.priorityId,
          reportedBy: formData.reportedBy && typeof formData.reportedBy === 'object' ? formData.reportedBy.value : formData.reportedBy,
          description: formData.description,
          moduleIds: formData.affectedId ? formData.affectedId.join(",") : null,
          SynergyAttachmentList: Array.isArray(formData.attachments)
            ? formData.attachments.map(attachment => ({
              fileName: attachment.fileName,
              base64File: attachment.base64Data
            }))
            : [],
          benefit: formData.benefit,
          IsAnalysisDocument: false,
          businessValue: formData.businessValue,
          considerations: formData.considerations,
          expectedOutcomes: formData.expectedOutcomes,
          proposedBy: formData.proposedBy,
          reasonForChange: formData.reasonForChange,
          submittedDate: formData.submittedDate ? formData.submittedDate : new Date(),
          userGoal: formData.userGoal,
          acceptanceCriteria: formData.acceptanceCriteria,
          userStoryID: formData.userStoryID,
        }
        addProjectSynergy(request);
      }
    }
  };
  useEffect(() => {
    if (isaddProjectSynergySucess && addProjectSynergyData) {
      const formData = SynergyRef.current.getFormData();
      ToastService.success(addProjectSynergyData.errorMessage);
      addProjectSynergySucess(projectIdData, formData?.synergyTypeID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isaddProjectSynergySucess, addProjectSynergyData]);

  const addProjectSynergySucess = (projectIdData, synergyType) => {
    let activeTab = 0;
    // Decide which tab should be active based on synergyType
    if (synergyType === 3) {
      activeTab = 1;
    } else if (synergyType === 2) {
      activeTab = 2;
    } else {
      activeTab = 0;
    }
    const dataToEncrypt = {
      ...projectIdData,
      activeTab: activeTab,
    };
    const encryptedData = encryptUrlData(dataToEncrypt);
    projectIdData.synergyType = synergyType
    const basePath = location.pathname.includes("/admin/project")
      ? "/admin/project/projectSynergy/"
      : "/myprojects/projectSynergy/";
    navigate(`${basePath}${encryptedData}`, {
      state: { fromProjectSynergy: true }
    });
  }

  const backToList = () => {
    if (projectIdData) {
      const encryptedData = encryptUrlData(projectIdData);
      const basePath = location.pathname.includes("/admin/project")
        ? "/admin/project/projectSynergy/"
        : "/myprojects/projectSynergy/";

      navigate(`${basePath}${encryptedData}`, {
        state: { fromProjectSynergy: true }
      });
    }
  };

  return (
    <div className="main-page-scroll add-edit-userpage">
      <div className="center-top-space">
        <CardSection
          isContentLoading={isAllSynergyPriorityFetching}
          cardTitle={`${projectCode || ''} - ${projectName || ''}  Synergy Information`}
        >
          <div className="row">
            <FormCreator
              key={shouldFormCretoerRerender}
              ref={SynergyRef}
              config={synergyForm}
              onColumnChange={handleFieldChange}
            />

          </div>
          <div className="d-flex justify-content-end mt-2 right-align">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={backToList}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn  ml-4"
              buttonText={"Add"}
              onClick={handleSubmit}
              isLoading={isaddProjectSynergyAddding}
            />
          </div>
        </CardSection>
      </div>
    </div>
  )
}
export default AddProjectSynergy;